module.exports = __webpack_public_path__ + "img/BMW.92e1cc50.png";